var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout", attrs: { id: "app" } },
    [
      _c(
        "Modal",
        {
          attrs: {
            value: _vm.is_show_browser,
            title: _vm.$t("app.broswer"),
            closable: false,
            "mask-closable": false,
            "footer-hide": true
          }
        },
        [
          _c("p", [
            _vm._v(
              "\n      " + _vm._s(_vm._f("t")("app.broswer0")) + "\n      "
            ),
            _vm.OS_name == "mac"
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: "http://download.nikemoment.com/googlechrome.dmg",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("t")("app.broswer1")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.OS_name == "windows"
              ? _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "http://download.nikemoment.com/ChromeStandaloneSetup64.exe",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("t")("app.broswer1")))]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.OS_name != "mac" && _vm.OS_name != "windows"
            ? _c("p", [
                _vm._v(
                  "\n      " + _vm._s(_vm._f("t")("app.broswer1")) + "\n    "
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "Layout",
        {
          class: !_vm.is_show_header ? "login_bg" : "no_bg",
          style: { height: "100%" }
        },
        [
          _vm.is_show_header
            ? _c("Header", [
                _c("h2", {
                  class: !_vm.is_ipad
                    ? "iconfont icon-emoment"
                    : "iconfont icon-emoment icon_center"
                }),
                _vm._v(" "),
                _c("div", [
                  !_vm.is_ipad
                    ? _c(
                        "div",
                        {
                          staticClass: "item logout",
                          attrs: { id: "exit" },
                          on: { click: _vm.logout }
                        },
                        [
                          _c("Icon", {
                            staticClass: "icon_btn",
                            attrs: { type: "ios-log-out" }
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(_vm._s(_vm._f("t")("session.logout")))
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_ipad
                    ? _c(
                        "div",
                        {
                          staticClass: "item user",
                          attrs: { id: "personal" },
                          on: {
                            click: function($event) {
                              _vm.show_me_drawer = !_vm.show_me_drawer
                            }
                          }
                        },
                        [
                          _c("img", { attrs: { src: _vm.user_avatar } }),
                          _vm._v(" "),
                          _c("h5", { staticClass: "down" }, [
                            _vm._v(_vm._s(_vm.user_name))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: _vm.is_ipad
                        ? "item language icon_right"
                        : "item language"
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/icon_language.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "Dropdown",
                        {
                          attrs: {
                            id: "swtich_lang_dropdown",
                            trigger: "click"
                          },
                          on: { "on-click": _vm.switchLang }
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.current_lang) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "DropdownMenu",
                            { attrs: { slot: "list" }, slot: "list" },
                            _vm._l(_vm.lang_list, function(item, index) {
                              return _c(
                                "DropdownItem",
                                {
                                  key: index,
                                  attrs: {
                                    name: index,
                                    id: "swtich_lang_dropdown_" + index
                                  }
                                },
                                [_vm._v(_vm._s(item) + "\n              ")]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.is_admin && !_vm.is_ipad
                    ? _c(
                        "div",
                        {
                          staticClass: "item home",
                          attrs: { id: "system" },
                          on: { click: _vm.gotoAdminPortal }
                        },
                        [
                          _c("img", {
                            attrs: { src: "/static/images/system_admin.svg" }
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(_vm._s(_vm._f("t")("system_admin")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.is_show_home_button
                    ? _c(
                        "div",
                        {
                          staticClass: "item home",
                          style: _vm.is_ipad
                            ? "position:absolute;right:100px;"
                            : "",
                          on: { click: _vm.gotoEventList }
                        },
                        [
                          _c("img", {
                            attrs: { src: "/static/images/icon_home.svg" }
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(_vm._s(_vm._f("t")("session.home")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_ipad
                    ? _c(
                        "div",
                        {
                          staticClass: "item notice",
                          on: { click: _vm.showNotice }
                        },
                        [
                          _c(
                            "Badge",
                            {
                              attrs: {
                                count: _vm.notice.unread_count,
                                offset: [8, 7]
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../static/images/icon_通知公告管理.svg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("h5", [_vm._v(_vm._s(_vm.$t("notice")))])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.channel_list.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "item home",
                          attrs: { id: "broadcaster" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ name: "ChannelList" })
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: "/static/images/broadcaster.svg" }
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("litter_helper.broadcaster")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_ipad &&
                  _vm.is_show_home_button &&
                  _vm.current_stage != 10 &&
                  _vm.user_identify_list &&
                  _vm.user_identify_list.length > 1
                    ? _c(
                        "div",
                        { staticClass: "item user_identify" },
                        [
                          _c(
                            "Dropdown",
                            {
                              staticStyle: {
                                height: "50px",
                                position: "relative",
                                top: "20px"
                              },
                              attrs: { trigger: "click" },
                              on: { "on-click": _vm.changeIdentify }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "white",
                                    height: "40px",
                                    position: "relative",
                                    top: "-20px"
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      width: "26px",
                                      height: "26px",
                                      src: "/static/images/icon_participant.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.identify_text(
                                                _vm.current_user_identify
                                              )
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("Icon", {
                                        attrs: { type: "ios-arrow-down" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "DropdownMenu",
                                { attrs: { slot: "list" }, slot: "list" },
                                _vm._l(_vm.user_identify_list || [], function(
                                  iden,
                                  index
                                ) {
                                  return _c(
                                    "DropdownItem",
                                    {
                                      key: index,
                                      attrs: { name: iden },
                                      on: {
                                        click: function($event) {
                                          return _vm.changeIdentify(iden)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(_vm.identify_text(iden))
                                        ) + "\n              "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_ipad && _vm.is_show_home_button && _vm.has_mdtf
                    ? _c(
                        "div",
                        { staticClass: "item", on: { click: _vm.gotoMDTF } },
                        [
                          _c("img", {
                            staticStyle: {
                              height: "32px",
                              width: "32px",
                              "margin-bottom": "4px"
                            },
                            attrs: { src: "/static/images/mdtf/GOPAL.svg" }
                          }),
                          _vm._v(" "),
                          _c(
                            "h5",
                            { staticStyle: { "letter-spacing": "1px" } },
                            [_vm._v("PAL")]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _vm.is_show_header
            ? _c(
                "Footer",
                {
                  staticClass: "footer_meetingzen",
                  class: { session_footer: _vm.is_session_footer }
                },
                [
                  _c("a", { attrs: { href: "/Privacy" } }, [
                    _vm._v(_vm._s(_vm._f("t")("privacy")))
                  ]),
                  _vm._v("\n      POWERED BY NIKE\n    ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.is_mobile && _vm.isMobilePath
            ? _c(
                "van-tabbar",
                {
                  staticStyle: { "z-index": "1000" },
                  on: {
                    change: function($event) {
                      return _vm.mobileGoTo(_vm.mobile_menu)
                    }
                  },
                  model: {
                    value: _vm.mobile_menu,
                    callback: function($$v) {
                      _vm.mobile_menu = $$v
                    },
                    expression: "mobile_menu"
                  }
                },
                [
                  _c(
                    "van-tabbar-item",
                    {
                      attrs: {
                        name: "/mobile/mobileEventList",
                        icon: "todo-list-o"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("mobile.event_list")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-tabbar-item",
                    { attrs: { name: "/mobile/passCard", icon: "qr" } },
                    [_vm._v(_vm._s(_vm.$t("mobile.pass_card")))]
                  ),
                  _vm._v(" "),
                  _c("van-tabbar-item", {
                    attrs: { name: "/mobile/mySport", icon: "contact" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function(props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "padding-top": "5px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-bottom": "4px" } },
                                    [
                                      _c("Icon", {
                                        attrs: { size: "22", type: "ios-walk" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.$t("mobile.my_sport")))
                                  ])
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      828104586
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          attrs: {
            title: "",
            closable: false,
            mask: false,
            "class-name": "me_style",
            width: "280"
          },
          model: {
            value: _vm.show_me_drawer,
            callback: function($$v) {
              _vm.show_me_drawer = $$v
            },
            expression: "show_me_drawer"
          }
        },
        [
          _c(
            "div",
            { staticClass: "avatar_c" },
            [
              _c("div", {
                staticClass: "img",
                style: { backgroundImage: "url(" + _vm.user_avatar + ")" }
              }),
              _vm._v(" "),
              _c("upload-file", {
                ref: "upload_avatar",
                staticClass: "upload_avatar",
                attrs: {
                  "change-action": _vm.uploadAvatar,
                  "button-name": "register.upload_avatar",
                  "button-id": "upload_avatar",
                  "accept-type": ".png,.jpg,.jpeg",
                  "button-icon": "",
                  "button-size": "small"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Form",
            [
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.name") } },
                [
                  _c("Input", {
                    attrs: {
                      type: "text",
                      maxlength: "20",
                      "show-word-limit": true
                    },
                    model: {
                      value: _vm.user_info_detail.name,
                      callback: function($$v) {
                        _vm.$set(_vm.user_info_detail, "name", $$v)
                      },
                      expression: "user_info_detail.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("FormItem", { attrs: { label: _vm.$t("register.phone") } }, [
                _c("div", { staticClass: "phone_c" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user_info_detail.login_phone_prefix,
                          expression: "user_info_detail.login_phone_prefix"
                        }
                      ],
                      attrs: { disabled: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.user_info_detail,
                            "login_phone_prefix",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.prefix_list, function(item, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: item.key } },
                        [_vm._v(_vm._s(item.value) + "\n            ")]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user_info_detail.login_phone,
                        expression: "user_info_detail.login_phone"
                      }
                    ],
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.user_info_detail.login_phone },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.user_info_detail,
                          "login_phone",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.user_info_detail.login_phone &&
                  _vm.user_info_detail.login_phone.length == 0
                    ? _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: { click: _vm.showPhoneChangeModal }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("t")("register.change")) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("FormItem", { attrs: { label: _vm.$t("register.email") } }, [
                _c("div", { staticClass: "email_c" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user_info_detail.login_email,
                        expression: "user_info_detail.login_email"
                      }
                    ],
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.user_info_detail.login_email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.user_info_detail,
                          "login_email",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.user_info_detail.login_email &&
                  _vm.user_info_detail.login_email.length == 0
                    ? _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: { click: _vm.showEmailChangeModal }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("t")("register.change")) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.user_info_detail.is_pwd
                ? _c("FormItem", [
                    _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("user.password")) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [
                        _c("Input", {
                          attrs: {
                            password: "",
                            disabled: "",
                            placeholder: _vm.$t("register.password"),
                            type: "password",
                            value: "********"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              padding: "10px",
                              "line-height": "12px",
                              cursor: "pointer",
                              position: "absolute",
                              "font-size": "14px",
                              color: "#fff",
                              "font-weight": "700",
                              "border-radius": "2px",
                              "background-color": "#595959",
                              top: "0",
                              right: "0",
                              "z-index": "2000"
                            },
                            on: { click: _vm.change_pwd_handler }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("change_password")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.account_group") } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        placeholder: _vm.$t("register.select_account_group")
                      },
                      model: {
                        value: _vm.user_info_detail.company_code,
                        callback: function($$v) {
                          _vm.$set(_vm.user_info_detail, "company_code", $$v)
                        },
                        expression: "user_info_detail.company_code"
                      }
                    },
                    _vm._l(_vm.company_list, function(item, index) {
                      return _c(
                        "Option",
                        { key: index, attrs: { value: item.company_code } },
                        [_vm._v(_vm._s(item.company_code) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.gender") } },
                [
                  _c(
                    "RadioGroup",
                    {
                      staticStyle: { display: "block" },
                      model: {
                        value: _vm.user_info_detail.gender,
                        callback: function($$v) {
                          _vm.$set(_vm.user_info_detail, "gender", $$v)
                        },
                        expression: "user_info_detail.gender"
                      }
                    },
                    _vm._l(_vm.gender_list, function(item, index) {
                      return _c(
                        "Radio",
                        { key: index, attrs: { label: index } },
                        [
                          _vm._v(
                            _vm._s(_vm._f("t")("register['" + item + "']")) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.area") } },
                [
                  _c("Input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.user_info_detail.location,
                      callback: function($$v) {
                        _vm.$set(_vm.user_info_detail, "location", $$v)
                      },
                      expression: "user_info_detail.location"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.city") } },
                [
                  _c("Input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.user_info_detail.city,
                      callback: function($$v) {
                        _vm.$set(_vm.user_info_detail, "city", $$v)
                      },
                      expression: "user_info_detail.city"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.company") } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        disabled:
                          _vm.user_info_detail.company != null &&
                          _vm.user_info_detail.company.length > 0
                      },
                      model: {
                        value: _vm.user_company,
                        callback: function($$v) {
                          _vm.user_company = $$v
                        },
                        expression: "user_company"
                      }
                    },
                    _vm._l(_vm.user_company_list, function(item, index) {
                      return _c(
                        "Option",
                        { key: index, attrs: { value: item.tag_value } },
                        [_vm._v(_vm._s(item.tag_value) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.language") } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        placeholder: _vm.$t("register.select_language")
                      },
                      model: {
                        value: _vm.user_info_detail.language,
                        callback: function($$v) {
                          _vm.$set(_vm.user_info_detail, "language", $$v)
                        },
                        expression: "user_info_detail.language"
                      }
                    },
                    _vm._l(_vm.lang_list, function(item, index) {
                      return _c(
                        "Option",
                        { key: index, attrs: { value: index } },
                        [_vm._v(_vm._s(item) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.tag1") } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        multiple: "",
                        "max-tag-count": 1,
                        placeholder: _vm.$t("register.tag1")
                      },
                      model: {
                        value: _vm.tag1_value,
                        callback: function($$v) {
                          _vm.tag1_value = $$v
                        },
                        expression: "tag1_value"
                      }
                    },
                    _vm._l(_vm.tag1_list, function(item) {
                      return _c(
                        "Option",
                        { key: item.tag_id, attrs: { value: item.tag_value } },
                        [_vm._v(_vm._s(item.tag_value) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.tag2") } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        multiple: "",
                        "max-tag-count": 1,
                        placeholder: _vm.$t("register.tag2")
                      },
                      model: {
                        value: _vm.tag2_value,
                        callback: function($$v) {
                          _vm.tag2_value = $$v
                        },
                        expression: "tag2_value"
                      }
                    },
                    _vm._l(_vm.tag2_list, function(item) {
                      return _c(
                        "Option",
                        { key: item.tag_id, attrs: { value: item.tag_value } },
                        [_vm._v(_vm._s(item.tag_value) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.tag3") } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        multiple: "",
                        "max-tag-count": 1,
                        placeholder: _vm.$t("register.tag3")
                      },
                      model: {
                        value: _vm.tag3_value,
                        callback: function($$v) {
                          _vm.tag3_value = $$v
                        },
                        expression: "tag3_value"
                      }
                    },
                    _vm._l(_vm.tag3_list, function(item) {
                      return _c(
                        "Option",
                        { key: item.tag_id, attrs: { value: item.tag_value } },
                        [_vm._v(_vm._s(item.tag_value) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-footer" }, [
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: { click: _vm.close_user_drawer }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("session.cancel")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              { attrs: { type: "button" }, on: { click: _vm.updateMe } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("session.save")) +
                    "\n      "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          attrs: {
            closable: false,
            mask: false,
            "class-name": "me_style",
            width: "280"
          },
          model: {
            value: _vm.change_pwd_drawer,
            callback: function($$v) {
              _vm.change_pwd_drawer = $$v
            },
            expression: "change_pwd_drawer"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "font-size": "18px", "font-weight": "700" } },
            [_vm._v("\n      " + _vm._s(_vm.$t("change_password")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ivu-form-item-content" },
            [
              _c("Input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.is_pwd,
                    expression: "!is_pwd"
                  }
                ],
                staticStyle: { margin: "10px 0" },
                attrs: {
                  password: "",
                  disabled: _vm.is_pwd,
                  placeholder: _vm.$t("register.old_password"),
                  type: "password"
                },
                model: {
                  value: _vm.login_pwd,
                  callback: function($$v) {
                    _vm.login_pwd = $$v
                  },
                  expression: "login_pwd"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.is_pwd,
                      expression: "is_pwd"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticStyle: { margin: "15px 0" } },
                    [
                      _c("Input", {
                        attrs: {
                          password: "",
                          placeholder: _vm.$t("register.new_password"),
                          type: "password"
                        },
                        model: {
                          value: _vm.new_pwd,
                          callback: function($$v) {
                            _vm.new_pwd = $$v
                          },
                          expression: "new_pwd"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "2px",
                            "font-size": "12px",
                            color: "#969696"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("register.pwd_placeholder")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Input", {
                    attrs: {
                      password: "",
                      placeholder: _vm.$t("register.confirm_password"),
                      type: "password"
                    },
                    model: {
                      value: _vm.confirm_pwd,
                      callback: function($$v) {
                        _vm.confirm_pwd = $$v
                      },
                      expression: "confirm_pwd"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "drawer-footer",
              staticStyle: { "margin-top": "20px" }
            },
            [
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: { click: _vm.verify_password }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("t")("session.okText")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.change_pwd_drawer = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("t")("session.cancel")) +
                      "\n      "
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          attrs: {
            title: "",
            closable: false,
            mask: false,
            "class-name": "me_style",
            width: "280"
          },
          model: {
            value: _vm.change_phone_number_drawer,
            callback: function($$v) {
              _vm.change_phone_number_drawer = $$v
            },
            expression: "change_phone_number_drawer"
          }
        },
        [
          _c(
            "Form",
            [
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.old_phone") } },
                [
                  _c("div", { staticClass: "phone_c" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user_info_detail.login_phone_prefix,
                            expression: "user_info_detail.login_phone_prefix"
                          }
                        ],
                        attrs: { disabled: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.user_info_detail,
                              "login_phone_prefix",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.prefix_list, function(item, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: item.key } },
                          [_vm._v(_vm._s(item.value) + "\n            ")]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user_info_detail.login_phone,
                          expression: "user_info_detail.login_phone"
                        }
                      ],
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.user_info_detail.login_phone },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.user_info_detail,
                            "login_phone",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.new_phone") } },
                [
                  _c("div", { staticClass: "phone_c" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.update_phone_obj.prefix,
                            expression: "update_phone_obj.prefix"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.update_phone_obj,
                              "prefix",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.prefix_list, function(item, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: item.key } },
                          [_vm._v(_vm._s(item.value) + "\n            ")]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.update_phone_obj.phone,
                          expression: "update_phone_obj.phone"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.update_phone_obj.phone },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.update_phone_obj,
                            "phone",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.validation_code") } },
                [
                  _c("div", { staticClass: "phone_c validation_code" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.update_phone_obj.validation_code,
                          expression: "update_phone_obj.validation_code"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.update_phone_obj.validation_code },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.update_phone_obj,
                            "validation_code",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "validation",
                        attrs: {
                          type: "button",
                          disabled: _vm.update_phone_countdown != 60
                        },
                        on: { click: _vm.send_sms_validation_code }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.update_phone_btn_txt) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-footer" }, [
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.change_phone_number_drawer = false
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("session.cancel")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: { click: _vm.check_sms_validation_code_update_phone }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("session.save")) +
                    "\n      "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          attrs: {
            title: "",
            closable: false,
            mask: false,
            "class-name": "me_style",
            width: "280"
          },
          model: {
            value: _vm.change_email_drawer,
            callback: function($$v) {
              _vm.change_email_drawer = $$v
            },
            expression: "change_email_drawer"
          }
        },
        [
          _c(
            "Form",
            [
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.old_email") } },
                [
                  _c("div", { staticClass: "email_c" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user_info_detail.login_email,
                          expression: "user_info_detail.login_email"
                        }
                      ],
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.user_info_detail.login_email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.user_info_detail,
                            "login_email",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.new_email") } },
                [
                  _c("div", { staticClass: "email_c" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email_validation.email,
                          expression: "email_validation.email"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.email_validation.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.email_validation,
                            "email",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: _vm.$t("register.validation_code") } },
                [
                  _c("div", { staticClass: "phone_c validation_code" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email_validation.code,
                          expression: "email_validation.code"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.email_validation.code },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.email_validation,
                            "code",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "validation",
                        attrs: {
                          type: "button",
                          disabled: _vm.update_phone_countdown != 60
                        },
                        on: { click: _vm.sendEmailValidationCode }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.update_phone_btn_txt) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-footer" }, [
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.change_email_drawer = false
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("session.cancel")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: { click: _vm.validationEmailCode }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("session.save")) +
                    "\n      "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("noticeModal", {
        ref: "noticeModal",
        attrs: {
          show: _vm.notice.isShow,
          pop_notice_list: _vm.notice.pop_notice_list,
          unread_count: _vm.notice.unread_count,
          total_count: _vm.notice.total_count
        },
        on: {
          "update:show": function($event) {
            return _vm.$set(_vm.notice, "isShow", $event)
          },
          "update:pop_notice_list": function($event) {
            return _vm.$set(_vm.notice, "pop_notice_list", $event)
          },
          "update:unread_count": function($event) {
            return _vm.$set(_vm.notice, "unread_count", $event)
          },
          "update:total_count": function($event) {
            return _vm.$set(_vm.notice, "total_count", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("cropperImg", {
        ref: "cropperImg",
        attrs: {
          uploadUrl: "user/upload_user_avatar",
          file: _vm.file,
          title: _vm.$t("register.upload_avatar"),
          options: _vm.cropperOptions,
          width: 500,
          originStyle: { width: "200px", height: "100px" },
          previewStyle: { width: "100px", height: "100px", borderRadius: "50%" }
        },
        on: {
          onUploadSuccess: function(url) {
            this$1.user_avatar = url
            _vm.$store.commit("setUserAvatar", url)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "pop_notice",
          staticClass: "notice",
          attrs: {
            styles: { top: _vm.pop_notice_top },
            width: "600",
            scrollable: "",
            closable: false
          },
          model: {
            value: _vm.is_pop_notice,
            callback: function($$v) {
              _vm.is_pop_notice = $$v
            },
            expression: "is_pop_notice"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "margin-bottom": "25px"
              },
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("notice_detail.new_notice")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("Icon", {
                staticStyle: { cursor: "pointer" },
                attrs: { size: "20", color: "#fff", type: "md-close" },
                on: {
                  click: function($event) {
                    _vm.is_pop_notice = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "all_read" }, [
            _c("span", { on: { click: _vm.set_all_readed } }, [
              _vm._v(_vm._s(_vm.$t("notice_detail.all_read")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "notice_container",
              staticStyle: { height: "431px" }
            },
            [
              _c(
                "div",
                { staticStyle: { height: "375px" } },
                _vm._l(_vm.notice.pop_notice_list, function(message) {
                  return _c(
                    "div",
                    { key: message.notice_id, staticClass: "message" },
                    [
                      _c(
                        "div",
                        { staticClass: "info" },
                        [
                          !message.is_viewed
                            ? _c(
                                "Badge",
                                { attrs: { dot: "", offset: [6, 4] } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "message_type",
                                      style: {
                                        color:
                                          _vm.notice_colors[
                                            _vm.$refs.noticeModal.get_notice_type(
                                              message
                                            )
                                          ]
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "notice_detail['" +
                                                _vm.$refs.noticeModal.get_notice_type(
                                                  message
                                                ) +
                                                "']"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "message_type",
                                  style: {
                                    color:
                                      _vm.notice_colors[
                                        _vm.$refs.noticeModal.get_notice_type(
                                          message
                                        )
                                      ]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "notice_detail['" +
                                            _vm.$refs.noticeModal.get_notice_type(
                                              message
                                            ) +
                                            "']"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _c("div", { staticClass: "message_title" }, [
                              _vm._v(_vm._s(message.title))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "message_time" }, [
                              message.event_name
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name",
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "event_name" },
                                            [_vm._v(_vm._s(message.event_name))]
                                          ),
                                          _vm._v(" "),
                                          message.session_name
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "session_name",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        margin: "0 3px"
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(">"))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        message.session_name
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: {
                                          background: "rgb(117, 117, 117)",
                                          width: "2px",
                                          height: "14px",
                                          margin: "0 10px"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        message.due_time
                                          ? message.due_time
                                          : message.created_at
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "view",
                          on: {
                            click: function($event) {
                              return _vm.viewNoticeDetail(message)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("notice_detail.view")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("Page", {
                attrs: {
                  total: _vm.notice.total_count,
                  "page-size": 5,
                  current: _vm.notice.getNoticeListParams.page_index,
                  size: "small",
                  "show-total": ""
                },
                on: { "on-change": _vm.changPage }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "pop_a_notice",
          staticClass: "pop_a_notice",
          attrs: { width: "600", scrollable: "", closable: false },
          model: {
            value: _vm.pop_a_notice,
            callback: function($$v) {
              _vm.pop_a_notice = $$v
            },
            expression: "pop_a_notice"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { "text-align": "right", "margin-bottom": "15px" },
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("Icon", {
                staticStyle: { cursor: "pointer" },
                attrs: { size: "20", color: "#fff", type: "md-close" },
                on: {
                  click: function($event) {
                    _vm.pop_a_notice = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "message" }, [
            _c(
              "div",
              { staticClass: "info" },
              [
                _c("Badge", { attrs: { dot: "", offset: [8, 8] } }, [
                  _c(
                    "div",
                    {
                      staticClass: "message_type",
                      style: {
                        color:
                          _vm.$refs.noticeModal &&
                          _vm.notice_colors[
                            _vm.$refs.noticeModal.get_notice_type(
                              _vm.notice.new_notice
                            )
                          ]
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "notice_detail['" +
                                (_vm.$refs.noticeModal &&
                                  _vm.$refs.noticeModal.get_notice_type(
                                    _vm.notice.new_notice
                                  )) +
                                "']"
                            )
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _c("div", { staticClass: "message_title" }, [
                    _vm._v(_vm._s(_vm.notice.new_notice.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message_time" }, [
                    _vm.notice.new_notice.event_name
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "name",
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c("div", { staticClass: "event_name" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.notice.new_notice.event_name) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.notice.new_notice.session_name
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "session_name",
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "center"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { margin: "0 3px" } },
                                          [_vm._v(_vm._s(">"))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.notice.new_notice.session_name
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                background: "rgb(117, 117, 117)",
                                width: "2px",
                                height: "14px",
                                margin: "0 10px"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("formatDate")(
                              _vm.notice.new_notice.due_time
                                ? _vm.notice.new_notice.due_time
                                : _vm.notice.new_notice.created_at
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "view",
                on: {
                  click: function($event) {
                    return _vm.viewNoticeDetail(_vm.notice.new_notice)
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("notice_detail.view")) +
                    "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      ),
      _vm._v(" "),
      _c("canvas", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        attrs: { id: "forSnapShot" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 